

"use client";

import { motion } from "framer-motion";
import Image from "next/image";

const StatsSection = () => {
  const stats = [
    {
      value: "32+",
      label: "Offices Across India",
      icon: "/assets/icon/icon1.png",
      bgColor: "bg-[#003265]",
    },
    {
      value: "10+",
      label: "Years of Industry Expertise",
      icon: "/assets/icon/icon2.png",
      bgColor: "bg-[#0068D2]",
    },
    {
      value: "ISO 9001:2015",
      label: "Certified",
            icon: "/assets/icon/icon3.png",
      bgColor: "bg-[#922D27]",
    },
    {
      value: "100+",
      label: "Privileged Clients",
            icon: "/assets/icon/icon4.png",
      bgColor: "bg-[#003265]",
    },
    {
      value: "24/7",
      label: "Operations",
            icon: "/assets/icon/icon5.png",
      bgColor: "bg-[#0068D2]",
    },
    {
      value: "400+",
      label: "Employees",
            icon: "/assets/icon/icon6.png",
      bgColor: "bg-[#003265]",
    },
    {
      value: "100+",
      label: "Vehicles",
            icon: "/assets/icon/icon7.png",
      bgColor: "bg-[#0068D2]",
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
      },
    },
  };

  return (
    <section className="relative py-16 overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: "url('/assets/photos/about/Asset-019.png')",
        }}
      >
        <div className="absolute inset-0 bg-[#b9cef0] opacity-90"></div>
      </div>

      <div className="max-w-6xl mx-auto px-4 relative z-10">
        {/* Section Title */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h1 className="text-2xl md:text-3xl font-bold text-[#034efc] mb-1">
            Delivering Efficiency with <span className="text-white"> Precision</span>
          </h1>
          <h2 className="text-sm md:text-sm font-bold text-black mb-1">
            A Legacy of Excellence Through Our Below Stats
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-blue-400 to-blue-300 mx-auto rounded-full"></div>
        </motion.div>

        {/* First Row - 3 cards */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={containerVariants}
          className="flex justify-center mb-6"
        >
          <div className="grid grid-cols-1 md:grid-cols-3 gap-2 max-w-6xl mx-auto">
            {stats.slice(0, 3).map((stat, index) => (
              <motion.div
                key={index}
                variants={itemVariants}
                whileHover={{ scale: 1.05, y: -5 }}
                className={`${stat.bgColor} rounded-md p-6 shadow-2xl border border-white border-opacity-20`}
              >
                <div className="flex items-center space-x-4">
                  {/* Icon on the left */}
                  <div className="text-4xl flex-shrink-0">
                   <Image src={stat.icon} alt="Icons" width={80} height={80} />
                    </div>
                  {/* Content on the right */}
                  <div className="flex flex-col">
                    <div className="text-3xl font-bold text-white mb-1">
                      {stat.value}
                    </div>
                    <div className="text-white text-opacity-90 text-sm font-medium uppercase tracking-wider">
                      {stat.label}
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* Second Row - 4 cards */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={containerVariants}
          className="flex justify-center"
        >
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
            {stats.slice(3).map((stat, index) => (
              <motion.div
                key={index + 3}
                variants={itemVariants}
                whileHover={{ scale: 1.05, y: -5 }}
                className={`${stat.bgColor} rounded-sm p-6 shadow-2xl border border-white border-opacity-20`}
              >
                <div className="flex items-center space-x-4">
                  {/* Icon on the left */}
                  <div className="text-3xl flex-shrink-0">
                                       <Image src={stat.icon} alt="Icons" width={60} height={60} />
                  </div>
                  {/* Content on the right */}
                  <div className="flex flex-col">
                    <div className="text-2xl font-bold text-white mb-1">
                      {stat.value}
                    </div>
                    <div className="text-white text-opacity-90 text-xs font-medium uppercase tracking-wider">
                      {stat.label}
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* Bottom decorative line */}
        <motion.div
          initial={{ opacity: 0, scaleX: 0 }}
          whileInView={{ opacity: 1, scaleX: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.5 }}
          className="w-32 h-0.5 bg-gradient-to-r from-blue-400 to-blue-300 mx-auto rounded-full mt-12"
        ></motion.div>
      </div>
    </section>
  );
};

export default StatsSection;
